import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import {
  columnLocation,
  columnRequested,
  columnConditions,
  columnTools,
  hasColumn, columnStatus,
} from '@/constants/fields';
import MessageCell from '@/components/table/MessageCell';
import SimpleCell from '@/components/table/SimpleCell';
import ToggleCell from '@/components/table/ToggleCell';
import MarkdownCell from '@/components/table/MarkdownCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import workspaceConditionsMarkdown from '../helper';
import WorkspaceTools from './WorkspaceTools';

const WorkspaceRow = ({
  className,
  columns,
  onCheckBoxClick,
  selectable,
  upward,
  workspace,
}) => {
  const intl = useIntl();

  return (
    <NameDescriptionRow
      className={clsx('aridhia-workspace-row', className)}
      columns={columns}
      entity={workspace.requested ? 'workspace.requested' : 'workspace'}
      href={workspace.url}
      name={workspace.reference || workspace.name}
      onSelect={() => onCheckBoxClick(workspace.uuid)}
      selectable={selectable}
      selected={workspace.selected}
      asHref
      warning={workspace.requested}
    >
      {hasColumn(columns, columnLocation) && (<SimpleCell content={workspace.location} />)}
      {hasColumn(columns, columnConditions) && (
        <MarkdownCell value={workspaceConditionsMarkdown(workspace.compatibility, intl)} />
      )}
      {hasColumn(columns, columnStatus) && (
        <MessageCell className="td-category" messageId={workspace.requested ? 'status.requested' : 'status.active'} />
      )}
      {hasColumn(columns, columnRequested) && (<ToggleCell disabled checked={workspace.requested_before} />)}
      {hasColumn(columns, columnTools) && (
        <Table.Cell collapsing><WorkspaceTools upward={upward} workspace={workspace} /></Table.Cell>
      )}
    </NameDescriptionRow>
  );
};

export default WorkspaceRow;
